// src/Components/HeroSection.tsx
import React from 'react';
import './HeroSection.css';
import { useLanguage } from '../context/LanguageContext';

interface HeroSectionProps {
    titleEn: string;
    titleDa: string;
    descriptionEn: string;
    descriptionDa: string;
    imageSrc: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ titleEn, titleDa, descriptionEn, descriptionDa, imageSrc }) => {
    const { language, setLanguage } = useLanguage();

    return (
        <section className="hero-section">
            <div className="hero-content">
                <h1>
                    {language === 'en' ? titleEn : titleDa}
                </h1>
                <p>
                    {language === 'en' ? descriptionEn : descriptionDa}
                </p>
                <div className="hero-buttons">
                    <button onClick={() => setLanguage('en')} className="hero-button">ENGLISH</button>
                    <button onClick={() => setLanguage('da')} className="hero-button">DANISH</button>
                </div>
            </div>
            <div className="hero-image">
                <img src={imageSrc} alt="Hero" />
            </div>
        </section>
    );
};

export default HeroSection;
